import axios from 'axios';

export const IntegrationService = {
  async saveConfig(configType, data) {
    const res = await axios.put(`config/${configType}/`, {
      params: data,
    });

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async getConfig(configType) {
    const res = await axios.get(`config/${configType}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
